/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterCreateInternalUserRequest,
  PresenterError,
  PresenterIDResponse,
  PresenterInternalUser,
  PresenterInternalUserListResponse,
  PresenterInternalUserLoginRequest,
  PresenterInternalUserLoginResponse,
  PresenterInternalUserUpdateRequest,
  PresenterInternalUserUpdateResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AWebInternalUser<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get internal-user list
   *
   * @tags AWeb-Internal_User
   * @name GetAdminInternalUsers
   * @summary Get the internal-user list
   * @request GET:/admin/internal_users
   */
  getAdminInternalUsers = (
    query?: {
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterInternalUserListResponse;
      },
      any
    >({
      path: `/admin/internal_users`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create internal user
   *
   * @tags AWeb-Internal_User
   * @name PostAdminInternalUsers
   * @summary Create the internal user
   * @request POST:/admin/internal_users
   */
  postAdminInternalUsers = (
    body: PresenterCreateInternalUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterInternalUser;
      },
      any
    >({
      path: `/admin/internal_users`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description return internal user info
   *
   * @tags AWeb-Internal_User
   * @name GetAdminInternalUsersMe
   * @summary Internal User Info
   * @request GET:/admin/internal_users/me
   */
  getAdminInternalUsersMe = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterInternalUser;
      },
      any
    >({
      path: `/admin/internal_users/me`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update internal user
   *
   * @tags AWeb-Internal_User
   * @name PutAdminInternalUsersById
   * @summary Update the internal user
   * @request PUT:/admin/internal_users/{id}
   */
  putAdminInternalUsersById = (
    id: number,
    body: PresenterInternalUserUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterInternalUserUpdateResponse;
      },
      any
    >({
      path: `/admin/internal_users/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Internal User with id
   *
   * @tags AWeb-Internal_User
   * @name DeleteAdminInternalUsersById
   * @summary Delete the Internal User
   * @request DELETE:/admin/internal_users/{id}
   */
  deleteAdminInternalUsersById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/admin/internal_users/${id}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create session from OAuth Code, nonce for Replay Attacks
   *
   * @tags AWeb-Internal_User
   * @name PostAdminLogin
   * @summary Login with Google
   * @request POST:/admin/login
   */
  postAdminLogin = (
    body: PresenterInternalUserLoginRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterInternalUserLoginResponse;
      },
      any
    >({
      path: `/admin/login`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
